<sm-title-bar pageTitle="{{ 'employee_salary.title' | translate }}" [back]="true" [headerCustomTemplate]="addButton">
    <ng-template #addButton>
        <div class="employe_btn d-flex search-field" (click)="addSalary()">
          <button mat-flat-button color="accent" >
            <mat-icon class="material-icons-round" [inline]="true"
            >add</mat-icon>
            {{ 'employee_salary.btn_text' | translate }}
          </button>
        </div>
        
      </ng-template> </sm-title-bar>
<mat-card >
    <mat-card-header class="justify-content-between align-items-center mb-3">
      
       </mat-card-header>
    <div class="rounded-3 bg-light" *ngIf="!loader">
      <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="salaryData" [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate"
         >
      </sm-data-table>
    </div>
  </mat-card>
  

  
  <ng-template #menuTemplate let-rowvalue>
    <button mat-menu-item (click)="viewdetails(rowvalue)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>View details</span>
    </button>
    <button mat-menu-item (click)="editSalary(rowvalue)">
      <mat-icon class="material-icons-outlined">edit</mat-icon>
      <span>{{ 'employee_salary.opt_edit' | translate }}</span>
    </button>
    <button mat-menu-item (click)="deleteSalary(rowvalue)">
      <mat-icon class="material-icons-outlined">delete</mat-icon>
      <span>{{ 'employee_salary.opt_delete' | translate }}</span>
    </button>
    <!-- <button mat-menu-item *ngIf="rowvalue.status == 1 && rowvalue.toShowType =='parent'" (click)="openAddTime(rowvalue)">
      <mat-icon class="material-icons-outlined">link</mat-icon>
      <span>Add more</span>
    </button>
    <button mat-menu-item *ngIf="rowvalue.status == 1" (click)="removeTime(rowvalue)">
      <mat-icon class="material-icons-outlined">delete</mat-icon>
      <span>Remove</span>
    </button> -->
  </ng-template>
  <!-- <mat-paginator
  *ngIf="!loader"
    class="mt-4"
    [length]="datalength"
    [pageSize]="25"
    (page)="onPageChange($event)"
  >
  </mat-paginator> -->